module.exports = __webpack_public_path__ + "img/section3Tab3Icon1.440efa1f.png";